import React, { Fragment } from 'react';

import { useIntl } from 'react-intl-next';
import { di } from 'react-magnetic-di';

import {
	PopoverContent,
	SpotlightActions,
	SpotlightBody,
	SpotlightCard,
	SpotlightControls,
	SpotlightDismissControl,
	SpotlightFooter,
	SpotlightHeader,
	SpotlightHeadline,
	SpotlightPrimaryAction,
	SpotlightSecondaryAction,
} from '@atlaskit/spotlight';
import { useAnalytics } from '@atlassian/conversation-assistant-instrumentation/controllers/analytics';

import {
	useConversationAssistantSpotlightActions,
	useConversationAssistantSpotlightState,
} from '../../controllers/spotlight';

import messages from './messages';

export const ConversationAssistantOnboardingSpotlight = ({
	openRovoChat,
	onDismiss,
}: {
	openRovoChat?: (event: React.MouseEvent<HTMLElement>, analyticsEvent: any) => void;
	onDismiss: () => void;
}): React.JSX.Element => {
	di(useConversationAssistantSpotlightState);

	const { formatMessage } = useIntl();
	const { end } = useConversationAssistantSpotlightActions();
	const { activeSpotlight } = useConversationAssistantSpotlightState();
	const { sendAnalyticsEvent } = useAnalytics();

	const handleTryChat = (event: React.MouseEvent<HTMLElement>, analyticsEvent?: any) => {
		if (openRovoChat) {
			openRovoChat(event, analyticsEvent);
		}
		end();
		onDismiss();
		sendAnalyticsEvent({
			eventType: 'ui',
			// this is more of 'chatButtonClicked'
			action: 'dismissed',
			actionSubject: 'rovoChatButtonSpotlight',
		});
	};

	const handleDismiss = () => {
		end();
		onDismiss();
		sendAnalyticsEvent({
			eventType: 'ui',
			action: 'dismissButtonClicked',
			actionSubject: 'rovoChatButtonSpotlight',
		});
	};

	return (
		<Fragment>
			{activeSpotlight !== null && (
				<PopoverContent
					dismiss={handleDismiss}
					isVisible={activeSpotlight !== null}
					placement="bottom-start"
				>
					<SpotlightCard>
						<SpotlightHeader>
							<SpotlightHeadline>{formatMessage(messages.onboardingHeading)}</SpotlightHeadline>
							<SpotlightControls>
								<SpotlightDismissControl onClick={handleDismiss} />
							</SpotlightControls>
						</SpotlightHeader>
						<SpotlightBody>{formatMessage(messages.onboardingDescription)}</SpotlightBody>
						<SpotlightFooter>
							<SpotlightActions>
								<SpotlightSecondaryAction onClick={handleDismiss}>
									{formatMessage(messages.dismissOnboarding)}
								</SpotlightSecondaryAction>
								<SpotlightPrimaryAction onClick={handleTryChat}>
									{formatMessage(messages.tryChat)}
								</SpotlightPrimaryAction>
							</SpotlightActions>
						</SpotlightFooter>
					</SpotlightCard>
				</PopoverContent>
			)}
		</Fragment>
	);
};
